// Condicoes de entrega da requisicao, no contrato da API: prazo de entrega em
// dias, tipo de pagamento (tbl_tipo_pagamento), observacoes e valor minimo.
// Data de entrega, prazo de pagamento em dias, forma de pagamento e frete
// deixaram de existir: a data do pedido sai da aprovacao + prazo de entrega.

export const toNumber = (text) => {
    const value = parseFloat(String(text || "").replace(",", "."));
    return Number.isFinite(value) ? value : null;
};

const filled = (value) => value !== null && value !== undefined && value !== "";

export const formOf = (delivery) => ({
    delivery_days: delivery && filled(delivery.delivery_days) ? Number(delivery.delivery_days) : null,
    payment_term_id: (delivery && delivery.payment_term_id) || undefined,
    minimum_billing: delivery && filled(delivery.minimum_billing) ? String(delivery.minimum_billing).replace(".", ",") : "",
    notes: (delivery && delivery.notes) || "",
});

export const payloadOf = (form) => ({
    delivery_days: filled(form.delivery_days) ? Math.trunc(Number(form.delivery_days)) : null,
    payment_term_id: form.payment_term_id || null,
    minimum_billing: toNumber(form.minimum_billing),
    notes: (form.notes || "").trim() || null,
});

// O que a API exige para aprovar: prazo de entrega e tipo de pagamento.
export const deliveryComplete = (delivery) =>
    !!delivery && filled(delivery.delivery_days) && filled(delivery.payment_term_id);
